module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"merchant_name":"Имя мерчанта","cancelled":"Отмена","last_date":"Дата доступа","link_product":"Адрес продукта","product_id":"ID продукта"},"en":{"merchant_name":"Merchant name","cancelled":"cancelled","last_date":"Last date","link_product":"Product link","product_id":"Product ID"}}')
  delete Component.options._Ctor
}
